export default "__VITE_ASSET__DGYzYWAa__"